// OpenIntake brand tokens. Single source of truth for the palette used
// across the marketing page — see UI_BRANDING_GUIDELINES.md.
export const brand = {
  ivory: '#FDFCF9', // page background
  tan: '#F7F3EB', // section / card background
  sand: '#E8E2D8', // borders, dividers
  khaki: '#C4B99D', // grid lines, muted accents
  brown: '#3E301E', // headings, primary text
  taupe: '#6B5F4D', // body / secondary text
  copper: '#B5683C', // primary accent
  copperDark: '#A05A32', // accent hover
  copperTint: '#FFF5ED', // accent-tinted background
  copperTintHover: '#FFEBE0',
} as const;

export const serifItalic = {
  fontFamily: '"Instrument Serif", serif',
  fontStyle: 'italic',
} as const;

// Marketing CTAs: flat, sentence case, no glow. Overrides the template's
// gradient/bevel on contained buttons so every CTA on the page matches.
export const ctaButton = {
  borderRadius: '50px',
  px: 3,
  py: 1.25,
  fontSize: '0.95rem',
  fontWeight: 600,
  letterSpacing: 0,
  textTransform: 'none',
  boxShadow: 'none',
} as const;

export const ctaPrimary = {
  ...ctaButton,
  color: '#FFFFFF',
  backgroundColor: brand.brown,
  backgroundImage: 'none',
  border: `1px solid ${brand.brown}`,
  '&:hover': { backgroundColor: '#2A2015', backgroundImage: 'none', boxShadow: 'none' },
} as const;

export const ctaSecondary = {
  ...ctaButton,
  color: brand.brown,
  backgroundColor: 'transparent',
  border: `1px solid ${brand.khaki}`,
  '&:hover': { backgroundColor: brand.tan, borderColor: brand.taupe, boxShadow: 'none' },
} as const;
